import { render, staticRenderFns } from "./liberacion-sancion-observacion.vue?vue&type=template&id=36fc3143&"
import script from "./liberacion-sancion-observacion.vue?vue&type=script&lang=ts&"
export * from "./liberacion-sancion-observacion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports